import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <Link to="/" className="footer-logo">
            <img src="/images/logo.png" alt="Rajat Grover Logo" className="footer-logo-img" />
          </Link>
          <p>Cyber Security Expert &bull; Ethical Hacker &bull; Author &bull; Founder of <a href="https://fncareers.com/" target="_blank" rel="noopener noreferrer" style={{color: 'var(--accent)'}}>FN Careers</a></p>
          <p className="footer-tagline">"Success occurs when your dreams get bigger than your excuses."</p>
        </div>
        <div className="footer-grid">
          <div className="footer-col">
            <h4>Pages</h4>
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/services">Services</Link>
            <Link to="/portfolio">Portfolio</Link>
            <Link to="/books">Books by Rajat Grover</Link>
            <Link to="/contact">Contact</Link>
          </div>
          <div className="footer-col">
            <h4>Ventures</h4>
            <a href="https://zoflair.com/" target="_blank" rel="noopener noreferrer">Zoflair Technologies</a>
            <a href="https://shesafe.tech" target="_blank" rel="noopener noreferrer">SheSafe.tech</a>
            <a href="https://fncareers.com/" target="_blank" rel="noopener noreferrer">FN Careers</a>
            <span style={{color: 'var(--text2)', fontSize: '0.85rem'}}>Rivedya <span style={{fontSize: '0.65rem', color: 'var(--accent)', fontWeight: 600}}>NEW</span></span>
          </div>
          <div className="footer-col">
            <h4>Connect</h4>
            <a href="https://instagram.com/rajatrg" target="_blank" rel="noopener noreferrer">Instagram</a>
            <a href="https://in.linkedin.com/in/rajatgroverrg" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            <a href="https://www.youtube.com/channel/UCxHpxRphdCnKWbtZSPJUe-w" target="_blank" rel="noopener noreferrer">YouTube</a>
            <a href="https://www.facebook.com/rajatgroverrg/" target="_blank" rel="noopener noreferrer">Facebook</a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Rajat Grover. All rights reserved.</p>
          <div className="footer-links">
            <a href="https://www.crunchbase.com/person/rajat-grover-8a85" target="_blank" rel="noopener noreferrer">Crunchbase</a>
            <a href="https://www.goodreads.com/author/show/14812164.Rajat_Grover" target="_blank" rel="noopener noreferrer">Goodreads</a>
            <a href="https://www.amazon.in/Books-Rajat-Grover/s?rh=n%3A976389031%2Cp_27%3ARajat+Grover" target="_blank" rel="noopener noreferrer">Amazon</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
